export const states = {
    2: 'Bloqueado',
    1: 'Activo'
};